<template>
  <div class="backall">
    <div style="position: absolute;width: 100%;height: 100%;">
      <iframe id="testFrame" frameborder="0" :src="vedioSrc" width="100%" height="100%" allowfullscreen>
      </iframe>
    </div>
    <!-- 头部 -->
    <div class="tophand">
      <img class="tophandimg" src="../../../static/img/1M04/tophand.png">
      <div class="img-text-left">{{ nowDate }}</div>
      <!-- <div class="img-text-center">国家科技传播中心-1M04办公室</div> -->
      <div class="img-text-center">
        <img class="img-text-center-img" src="../../../static/img/1M04/gjkj.png">
      </div>
      <div class="img-text-right">天气 {{ weather }} {{ temp }}℃</div>
    </div>
    <!-- 中间 -->
    <div class="content-m">
      <img class="content-m-img" src="../../../static/img/1M04/gcdg.png">
      <div class="light" @click="lightClick()" id="lightoff">总照明</div>
      <div class="returnairLeft">
        <!-- <div :class="returnairimg"></div> -->
        回风:{{ airreturnL }}℃
      </div>
      <div class="airsupplyLeft">
        <!-- <div :class="airsupplyimg"></div> -->
        送风:{{ airsupplyL }}℃
      </div>
      <div class="leftAll">
        <div class="">
          制冷总量:{{ LgerationL }} KJ
        </div>
        <div :class="airsupplyimg"></div>
        <div class="">
          制热总量:{{ LheatingL }} KJ
        </div>
      </div>
      <div class="lightdan" @click="lightdan()" id="lightleft">照明</div>
      <div class="returnair">
        <!-- <div :class="returnairimg"></div> -->
        回风:{{ airreturn }}℃
      </div>
      <div class="airsupply">
        <!-- <div :class="airsupplyimg"></div> -->
        送风:{{ airsupply }}℃
      </div>
      <div class="rightAll">
        <div class="">
          制冷总量:{{ Lgeration }} KJ
        </div>
        <div :class="airsupplyimg"></div>
        <div class="">
          制热总量:{{ Lheating }} KJ
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="bottomhand">
      <div class="curve">
        <div class="curve-top">
          <img class="curve-top-img" src="../../../static/img/1M04/littlejiao.png">
          <div class="curve-text">实时数据曲线</div>
          <div class="record">
            <div class="record-tem"></div>
            <div class="record-s">温度： {{ TemData }}℃</div>
            <div class="record-hum"></div>
            <div class="record-s">湿度： {{ HumData }}RH%</div>
            <div class="record-car"></div>
            <div class="record-s">CO2： {{ CarData }}ppm</div>
            <div class="record-voc"></div>
            <div class="record-s">VOC： {{ VocData }}ppm</div>
          </div>
        </div>
        <div class="screw-main">
          <div ref="pieTen" style="width: 100%; height: 100%;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts';
import service from '../../service/leftService';
import axios from 'axios';

export default {
  name: '',
  props: [''],
  data() {
    return {
      nowDate: "",
      testArray: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',],
      testSize: 0,
      timer: null,
      vedioSrc: '', //https://open.ys7.com/jssdk/theme.html?url=ezopen://open.ys7.com/F08316479/1.live&autoplay=1&accessToken=at.4r91shq55jblaot258v0il2tdxmivpxv-4ckyary62m-139as06-xcrsalvuy&id=ysopen
      xData1: [], // 折线图温度曲线
      Data1: [], // 实时温度曲线
      TemData: '', // 处理后的温度数据
      xData2: [], // 折线图湿度曲线
      Data2: [], // 实时湿度曲线
      HumData: '', // 处理后的湿度数据
      xData3: [], // 折线图CO2曲线
      Data3: [], // 实时CO2曲线
      CarData: '', // 处理后的CO2数据
      xData4: [], // 折线图VOC曲线
      Data4: [], // 实时VOC曲线
      VocData: '', // 处理后的VOC数据
      lightOn: "",
      airsupply: "", // FAN0送风温度
      airreturn: "", // FAN0回风温度
      Lheating: "", // FAN0制热总量
      Lgeration: "", // FAN0制冷总量
      airsupplyL: "", // FAN1送风温度
      airreturnL: "", // FAN1回风温度
      LheatingL: "", // FAN1制热总量
      LgerationL: "", // FAN1制冷总量
      airnum: null,
      lightid: "", // 灯光id
      temp: '',
      weather: '',
      returnair: '', // 回风图片地址
      returnairimg: {
        returnairimg1: false,
        returnairimg2: false,
      },
      airsupplyimg: {
        airsupplyimg1: false,
        airsupplyimg2: false,
      },
      deng1Id: '', // 单开关
      deng1value: '', // 单开关
      dengZId: '', // 总开关
      dengZvalue: '', // 总开关
    }
  },

  components: {},

  computed: {},

  mounted() {
    this.currentTime(); // 获取当前时间
    this.$nextTick(() => {
      this.timer = setInterval(() => {
        this.getTime()
      }, 3000)
    })
    this.lightleftstate(); // 左侧灯光初始化状态
    this.lightstate(); // 总灯光初始化状态
    this.gettemperature(); // 送回风温度
    this.airnum = setInterval(() => {
      this.gettemperature()
    }, 3000)
    this.hefeng(); // 和风天气
    this.getTok()
    // setTimeout(() => {
    //   this.getTok() // 获取视频token
    // })
  },

  methods: {
    // 获取视频token 
    getTok() {
      service.tokenYingshi().then(res => {
        let token = res.accessToken
        this.vedioSrc = `https://open.ys7.com/jssdk/theme.html?url=ezopen://open.ys7.com/F08316479/1.live&autoplay=1&accessToken=${token}&id=ysopen`
      }).catch(err => {

      })
    },

    // 和风天气数据接口 cb8885d03abc4412ab83212e87a4fddf
    hefeng() {
      return new Promise((resovle, reject) => {
        $.ajax({
          type: 'GET',
          url: 'https://devapi.qweather.com/v7/weather/now?location=101010100&key=922ad60d9e864d70a66a9d17c411f722',
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          success: (data) => {
            this.temp = data.now.temp
            this.weather = data.now.text
          },
          erroe: (err) => {
            console.log(err)
          }
        })
      })
    },

    // 修改数据
    updateData(obj) {
      service.updatePhysicalPoint(obj).then(res => {
        this.$message.success('切换成功')
      }).catch(err => {
        this.$message.error('切换失败')
      })
    },

    // 获取总照明状态
    lightstate() {
      let obj = {
        "args": ['1M04总灯光数据接口']
      }
      service.getPublicData(obj).then(res => {
        this.dengZId = res[0].id
        this.dengZvalue = res[0].value
        res.forEach(item => {
          if (item.value == 1) {
            document.getElementById('lightoff').style.background = '#2e90e057';
          } else if (item.value == 0) {
            document.getElementById('lightoff').style.background = 'linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%)';
          };
        })
      });
    },

    // 获取东照明状态
    lightleftstate() {
      let _this = this;
      let obj1 = {
        "args": ['1M04总灯光数据接口']
      }
      service.getPublicData(obj1).then(res => {
        _this.dengZId = res[0].id
        _this.dengZvalue = res[0].value
        res.forEach(item => {
          if (item.value == 1) {
            document.getElementById('lightoff').style.background = '#2e90e057';
            document.getElementById('lightleft').style.background = '#2e90e057'; // 32b62385
          } else if (item.value == 0) {
            document.getElementById('lightoff').style.background = 'linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%)';
            document.getElementById('lightleft').style.background = 'linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%)';
          };
        })
      });
      let obj = {
        "args": ['1M04东灯光数据接口']
      }
      service.getPublicData(obj).then(res => {
        _this.deng1Id = res[0].id
        _this.deng1value = res[0].value
        res.forEach(item => {
          if (item.value == 1) {
            document.getElementById('lightleft').style.background = '#2e90e057'; // 32b62385
          } else if (item.value == 0) {
            document.getElementById('lightleft').style.background = 'linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%)';
          };
        })
      });
    },

    // 总照明开关
    lightClick() {
      if (this.dengZvalue == 1) {
        let obj = {
          id: this.dengZId,
          value: 0
        }
        this.updateData(obj)
        document.getElementById('lightoff').style.background = 'linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%)';
        document.getElementById('lightleft').style.background = 'linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%)';
        this.dengZvalue = 0
      }
      else {
        let obj = {
          id: this.dengZId,
          value: 1
        }
        this.updateData(obj)
        document.getElementById('lightoff').style.background = '#2e90e057';
        document.getElementById('lightleft').style.background = '#2e90e057';
        this.dengZvalue = 1
      }
      // let obj = {
      //   "args": ['1M04总灯光数据接口']
      // }
      // let _this = this;
      // service.getPublicData(obj).then(res => {
      //   this.deng1Id = res[0].id
      //   this.deng1value = res[0].value
      //   res.forEach(item => {
      //     if (item.value == 1) {
      //       _this.lightid = item.id
      //       let obj1 = {
      //         id: _this.lightid,
      //         value: 0,
      //       }
      //       this.updateData(obj1)
      //       document.getElementById('lightoff').style.background = 'linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%)';
      //     } else if (item.value == 0) {
      //       _this.lightid = item.id
      //       let obj1 = {
      //         id: _this.lightid,
      //         value: 1,
      //       }
      //       this.updateData(obj1)
      //       document.getElementById('lightoff').style.background = '#2e90e057';
      //     }
      //   })
      // });
    },

    // 东灯光照明开关
    lightdan() {
      if (this.deng1value == 1) {
        let obj = {
          id: this.deng1Id,
          value: 0
        }
        this.updateData(obj)
        document.getElementById('lightleft').style.background = 'linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%)';
        this.deng1value = 0
      }
      else {
        let obj = {
          id: this.deng1Id,
          value: 1
        }
        this.updateData(obj)
        document.getElementById('lightleft').style.background = '#2e90e057';
        this.deng1value = 1
      }
      // let obj = {
      //   "args": ['1M04东灯光数据接口']
      // }
      // let _this = this;
      // service.getPublicData(obj).then(res => {
      //   res.forEach(item => {
      //     if (item.value == 1) {
      //       _this.lightid = item.id
      //       let obj1 = {
      //         id: _this.lightid,
      //         value: 0,
      //       }
      //       this.updateData(obj1)
      //       document.getElementById('lightleft').style.background = 'linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%)';
      //     } else if (item.value == 0) {
      //       _this.lightid = item.id
      //       let obj1 = {
      //         id: _this.lightid,
      //         value: 1,
      //       }
      //       this.updateData(obj1)
      //       document.getElementById('lightleft').style.background = '#2e90e057';
      //     }
      //   })
      // });
    },

    // 获取送回风温度
    gettemperature() {
      let obj = {
        "args": ['1M04FAN0数据接口']
      }
      let obj1 = {
        "args": ['1M04FAN1数据接口']
      }
      let obj3 = {
        "args": ['1M04空调开关数据接口']
      }
      let _this = this;
      service.getPublicData(obj).then(res => {
        res.forEach(item => {
          // FAN0数据接口
          if (item.name == 'AIR_SA') { // 送风温度
            this.airsupply = item.value;
          }
          if (item.name == 'AR_HP') { // 制热总量
            this.Lheating = item.value;
          }
          if (item.name == 'AR_CP') { // 制冷总量
            this.Lgeration = item.value;
          }
          if (item.name == 'AIR_BA') { // 回风温度
            this.airreturn = item.value;
          }
        })
      }),
        service.getPublicData(obj1).then(res => {
          res.forEach(item => {
            // FAN1数据接口
            if (item.name == 'AIR_SA') { // 送风温度
              this.airsupplyL = item.value;
            }
            if (item.name == 'AR_HP') { // 制热总量
              this.LheatingL = item.value;
            }
            if (item.name == 'AR_CP') { // 制冷总量
              this.LgerationL = item.value;
            }
            if (item.name == 'AIR_BA') { // 回风温度
              this.airreturnL = item.value;
            }
          })
        }),
        // service.getPublicData(obj1).then(res => {
        //   res.forEach(item => {
        //     if (item.name == 'AIR_BA') {
        //       this.airreturn = item.value;
        //     }
        //   })
        // }),
        service.getPublicData(obj3).then(res => {
          res.forEach(item => {
            if (item.value == '1') {
              // _this.returnairimg.returnairimg1 = true;
              // _this.returnairimg.returnairimg2 = false;
              _this.airsupplyimg.airsupplyimg1 = true;
              _this.airsupplyimg.airsupplyimg2 = false;
            } else if (item.value == '0') {
              // _this.returnairimg.returnairimg1 = false;
              // _this.returnairimg.returnairimg2 = true;
              _this.airsupplyimg.airsupplyimg1 = false;
              _this.airsupplyimg.airsupplyimg2 = true;
            }
          })
        })
    },

    // 获取X轴时间
    getTime() {
      let myDate = new Date();
      let house = myDate.getHours();
      let minutes = myDate.getMinutes();
      let second = myDate.getSeconds();
      let time = house + ":" + minutes + ":" + second;
      let obj = {
        "args": ['1M04环境数据接口']
      }
      let _this = this;
      // 温度实时曲线获取
      service.getPublicData(obj).then(res => {
        if (_this.testSize > 900) {
          _this.testSize = 920
          _this.testArray.shift()
          _this.testArray.push(time)
        } else {
          _this.testArray.splice(_this.testSize, 1, time)
        }
        res.forEach(item => {
          if (item.name == 'AIR_Temp') {
            if (_this.testSize > 900) {
              _this.xData1.shift()
              _this.xData1.push(item.value)
            } else {
              _this.xData1.push(item.value)
            }
            if (_this.testSize > 0) {
              _this.Data1.shift()
              _this.Data1.push(item.value)
              // _this.Data1 = _this.Data1.map(Number);
              _this.TemData = _this.Data1.map(Data1 => Data1).join(', ');
            } else {
              _this.Data1.push(item.value)
              _this.TemData = _this.Data1.map(Data1 => Data1).join(', ');
            }
          }
          if (item.name == 'AIR_Humd') {
            if (_this.testSize > 900) {
              _this.xData2.shift()
              _this.xData2.push(item.value)
            } else {
              _this.xData2.push(item.value)
            }
            if (_this.testSize > 0) {
              _this.Data2.shift()
              _this.Data2.push(item.value)
              _this.HumData = _this.Data2.map(Data2 => Data2).join(', ');
            } else {
              _this.Data2.push(item.value)
              _this.HumData = _this.Data2.map(Data2 => Data2).join(', ');
            }
          }
          if (item.name == 'AIR_CO2') {
            if (_this.testSize > 900) {
              _this.xData3.shift()
              _this.xData3.push(item.value)
            } else {
              _this.xData3.push(item.value)
            }
            if (_this.testSize > 0) {
              _this.Data3.shift()
              _this.Data3.push(item.value)
              _this.CarData = _this.Data3.map(Data3 => Data3).join(', ');
            } else {
              _this.Data3.push(item.value)
              _this.CarData = _this.Data3.map(Data3 => Data3).join(', ');
            }
          }
          if (item.name == 'AIR_VOC') {
            if (_this.testSize > 900) {
              _this.xData4.shift()
              _this.xData4.push(item.value)
            } else {
              _this.xData4.push(item.value)
            }
            if (_this.testSize > 0) {
              _this.Data4.shift()
              _this.Data4.push(item.value)
              _this.VocData = _this.Data4.map(Data4 => Data4).join(', ');
            } else {
              _this.Data4.push(item.value)
              _this.VocData = _this.Data4.map(Data4 => Data4).join(', ');
            }
          }
        })
        this.testSize++
        this.echartsInit()
      })
    },

    // 获取当前系统时间
    getDate() {
      let date = new Date();
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月
      month = month < 10 ? "0" + month : month; // 如果只有一位，则前面补零
      let day = date.getDate(); // 日
      day = day < 10 ? "0" + day : day; // 如果只有一位，则前面补零
      // let week = date.getDay(); // 星期
      // let weekArr = [
      //   "星期日",
      //   "星期一",
      //   "星期二",
      //   "星期三",
      //   "星期四",
      //   "星期五",
      //   "星期六",
      // ];
      let hour = date.getHours(); // 时
      hour = hour < 10 ? "0" + hour : hour; // 如果只有一位，则前面补零
      let minute = date.getMinutes(); // 分
      minute = minute < 10 ? "0" + minute : minute; // 如果只有一位，则前面补零
      let second = date.getSeconds(); // 秒
      second = second < 10 ? "0" + second : second; // 如果只有一位，则前面补零
      this.nowDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },

    //定时器调取当前时间
    currentTime() {
      this.dataTimer = setInterval(() => {
        this.getDate();
      }, 1000);
    },

    // echarts折线图
    echartsInit() {
      let pieTen = echarts.init(this.$refs.pieTen);
      pieTen.setOption(
        {
          tooltip: {
            trigger: 'axis',
            confine: true,
            persistent: true,
            // formatter: function (params) {
            //   var res = params[0].name + '<br/>';
            //   for (var i = 0, l = params.length; i < l; i++) {
            //     res += params[i].seriesName + ' : ' + params[i].value + ' 元<br/>';
            //   }
            //   return res;
            // },
            formatter: (params) => {
              return params[0].name + '<br>' +
                // tslint:disable-next-line:max-line-length
                params[0].marker + ' ' + params[0].seriesName + ': ' + params[0].data + ' ℃' + '<br>' +
                params[1].marker + ' ' + params[1].seriesName + ': ' + params[1].data + ' RH%' + '<br>' +
                params[2].marker + ' ' + params[2].seriesName + ': ' + params[2].data + ' ppm' + '<br>' +
                params[3].marker + ' ' + params[3].seriesName + ': ' + params[3].data + ' ppm';
            },
            axisPointer: {
              type: 'none', //cross 十字数值显示器
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          grid: {
            left: '0.5%',
            right: '2%',
            bottom: '2%',
            top: "8%",
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.testArray,
            axisLine: {
              lineStyle: {
                color: '#15ff00',
              }
            },
            axisLabel: {
              color: '#15ff00' // 设置x轴标签文字颜色
            },
          },
          yAxis: [
            { // 左侧y轴
              type: 'value',
              min: 0,
              max: 100,
              interval: 20,
              axisLine: {
                lineStyle: {
                  color: '#15ff00'
                }
              },
              axisLabel: {
                color: '#15ff00' // 设置x轴标签文字颜色
              },
              splitLine: {
                lineStyle: {
                  type: 'dashed',//虚线
                  color: '#15ff00'
                },
                show: true //隐藏
              }
            },
            { // 右侧y轴
              type: 'value',
              min: 0,
              max: 3000,
              interval: 600,
              axisLine: {
                lineStyle: {
                  color: '#15ff00'
                }
              },
              axisLabel: {
                color: '#15ff00' // 设置x轴标签文字颜色
              },
              splitLine: {
                lineStyle: {
                  // type: 'dashed',//虚线
                  // color: '#15ff00'
                  opacity: 0
                },
                show: true //隐藏
              }
            },
          ],
          series: [
            {
              name: '温度',
              type: 'line',
              smooth: true,
              // stack: 'Total',
              data: this.xData1,
              showSymbol: false,  //默认展示的时候没有圆圈出现
              yAxisIndex: 0, // 归属于左侧Y轴
              itemStyle: {
                color: '#ffa600'
              },
              // areaStyle: {
              //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              //     {
              //       offset: 0,
              //       color: '#00ffff34'
              //     },
              //     {
              //       offset: 1,
              //       color: '#00ffff34'
              //     }
              //   ])
              // },
            },
            {
              name: '湿度',
              type: 'line',
              smooth: true,
              data: this.xData2,
              showSymbol: false,  //默认展示的时候没有圆圈出现
              yAxisIndex: 0, // 归属于左侧Y轴
              itemStyle: {
                color: '#0086D0'
              },
              // areaStyle: {
              //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              //     {
              //       offset: 0,
              //       color: '#0087d0c7'
              //     },
              //     {
              //       offset: 1,
              //       color: '#0087d033'
              //     }
              //   ])
              // },
            },
            {
              name: 'CO2',
              type: 'line',
              smooth: true,
              data: this.xData3,
              showSymbol: false,  //默认展示的时候没有圆圈出现
              yAxisIndex: 1, // 归属于右侧Y轴
              itemStyle: {
                color: '#f700ff'
              },
              // areaStyle: {
              //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              //     {
              //       offset: 0,
              //       color: '#fff87246'
              //     },
              //     {
              //       offset: 1,
              //       color: '#fff87246'
              //     }
              //   ])
              // },
            },
            {
              name: 'VOC',
              type: 'line',
              smooth: true,
              data: this.xData4,
              showSymbol: false,  //默认展示的时候没有圆圈出现
              yAxisIndex: 1, // 归属于右侧Y轴
              itemStyle: {
                color: '#ae00ff'
              },
              // areaStyle: {
              //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              //     {
              //       offset: 0,
              //       color: '#c28b1457'
              //     },
              //     {
              //       offset: 1,
              //       color: '#c28b1457'
              //     }
              //   ])
              // },
            },
          ]
        },
      )
      window.addEventListener('resize', () => {
        pieTen.resize()
      })
    },
  },
}

</script>
<style lang='scss' scoped>
.backall {
  width: 100%;
  height: 100%;
  background-color: #000;
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  // background-image: url(../../../static/img/1M04/1M04.png);
  background-size: 100% 100%;
}

.tophand {
  width: 100%;
  position: relative;
  display: inline-block;
  // background-color: rgba(0, 0, 0, 0.1);
}

.tophandimg {
  width: 100%;
  height: 8vh;
}

.img-text-left {
  position: absolute;
  top: 31%;
  left: 7%;
  transform: translate(-50%, -50%);
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 2vh;
  color: #FFFFFF;
  // line-height: 30px;
}

.img-text-center {
  // width: 215px;
  position: absolute;
  left: 50%;
  letter-spacing: 0.8vh;
  top: 52%;
  transform: translate(-50%, -50%);
  // font-family: PingFang SC;
  font-weight: 400;
  font-size: 2vh;
  color: #FFFFFF;
  line-height: 30px;
}

.img-text-center-img {
  width: 67vh;
  height: 5vh;
}

.img-text-right {
  width: 150px;
  position: absolute;
  top: 31%;
  left: 95.5%;
  transform: translate(-50%, -50%);
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 2vh;
  color: #FFFFFF;
  line-height: 9px;
  letter-spacing: 3px
}

.content-m {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
}

.content-m-img {
  width: 100px;
  height: 100px;
  margin-left: 1%;
  position: absolute;
}

.light {
  width: 75px;
  height: 30px;
  background: linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%);
  border: 1px solid #15ff00;
  position: absolute;
  bottom: 64vh;
  left: 100vh;
  // left: 65vh;
  /* border-radius: 50%; */
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  color: #fff;
  cursor: pointer;
}

.lightdan {
  width: 75px;
  height: 30px;
  background: linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%);
  border: 1px solid #15ff00;
  position: absolute;
  bottom: 62vh;
  left: 52vh;
  /* border-radius: 50%; */
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  color: #fff;
  cursor: pointer;
}

.returnairLeft {
  width: 130px;
  height: 30px;
  // background: linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%);
  // border: 2px solid #1A87B6;
  color: #15ff00;
  position: absolute;
  bottom: 88vh;
  left: 40vh;
  padding-top: 1px;
  /* border-radius: 50%; */
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  // color: #fff;
  cursor: pointer;
}

.returnairLeft1 {
  width: 200px;
  height: 30px;
  // background: linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%);
  // border: 2px solid #1A87B6;
  color: #15ff00;
  position: absolute;
  bottom: 84vh;
  left: 36vh;
  padding-top: 1px;
  /* border-radius: 50%; */
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  // color: #fff;
  cursor: pointer;
}

.returnairLeft2 {
  width: 200px;
  height: 30px;
  // background: linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%);
  // border: 2px solid #1A87B6;
  color: #15ff00;
  position: absolute;
  bottom: 80vh;
  left: 36vh;
  padding-top: 1px;
  /* border-radius: 50%; */
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  // color: #fff;
  cursor: pointer;
}

.returnair {
  width: 130px;
  height: 30px;
  // background: linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%);
  // border: 2px solid #1A87B6;
  color: #15ff00;
  position: absolute;
  bottom: 86vh;
  right: 17vh;
  padding-top: 1px;
  /* border-radius: 50%; */
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  // color: #fff;
  cursor: pointer;
}

.returnair1 {
  width: 200px;
  height: 30px;
  // background: linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%);
  // border: 2px solid #1A87B6;
  color: #15ff00;
  position: absolute;
  bottom: 82vh;
  right: 13vh;
  padding-top: 1px;
  /* border-radius: 50%; */
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  // color: #fff;
  cursor: pointer;
}

.returnair2 {
  width: 200px;
  height: 30px;
  // background: linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%);
  // border: 2px solid #1A87B6;
  color: #15ff00;
  position: absolute;
  bottom: 78vh;
  right: 13vh;
  padding-top: 1px;
  /* border-radius: 50%; */
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  // color: #fff;
  cursor: pointer;
}

.returnairimg1 {
  width: 30px;
  height: 30px;
  margin-right: 3px;
  background-image: url("../../assets/diy/xuan.gif");
  background-size: 100% 100%;
}

.returnairimg2 {
  width: 20px;
  height: 20px;
  margin-right: 3px;
  background-image: url("../../assets/diy/xuan1.png");
  background-size: 100% 100%;
}

.airsupplyLeft {
  width: 130px;
  height: 30px;
  // background: linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%);
  // border: 2px solid #15ff00;
  // border: 2px solid #1A87B6;
  color: #15ff00;
  position: absolute;
  bottom: 75vh;
  left: 72vh;
  // bottom: 60vh;
  // right: 47vh;
  padding-top: 1px;
  /* border-radius: 50%; */
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  // color: #fff;
  cursor: pointer;
}

.leftAll {
  width: 500px;
  height: 30px;
  color: #15ff00;
  cursor: pointer;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  bottom: 81vh;
  left: 40vh;
  position: absolute;
}

.airsupplyLeft1 {
  width: 200px;
  height: 30px;
  // background: linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%);
  // border: 2px solid #15ff00;
  color: #15ff00;
  position: absolute;
  bottom: 84vh;
  left: 52vh;
  // bottom: 60vh;
  // right: 47vh;
  padding-top: 1px;
  /* border-radius: 50%; */
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  // color: #fff;
  cursor: pointer;
}

.airsupplyLeft2 {
  width: 200px;
  height: 30px;
  // background: linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%);
  // border: 2px solid #15ff00;
  color: #15ff00;
  position: absolute;
  bottom: 80vh;
  left: 52vh;
  // bottom: 60vh;
  // right: 47vh;
  padding-top: 1px;
  /* border-radius: 50%; */
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  // color: #fff;
  cursor: pointer;
}

.airsupply {
  width: 130px;
  height: 30px;
  // background: linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%);
  // border: 2px solid #15ff00;
  color: #15ff00;
  position: absolute;
  bottom: 73vh;
  right: 48vh;
  // bottom: 60vh;
  // right: 47vh;
  padding-top: 1px;
  /* border-radius: 50%; */
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  // color: #fff;
  cursor: pointer;
}

.rightAll {
  width: 500px;
  height: 30px;
  color: #15ff00;
  cursor: pointer;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  bottom: 80vh;
  right: 9vh;
  position: absolute;
}

.airsupply1 {
  width: 200px;
  height: 30px;
  // background: linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%);
  // border: 2px solid #15ff00;
  color: #15ff00;
  position: absolute;
  bottom: 81vh;
  right: 27vh;
  // bottom: 60vh;
  // right: 47vh;
  padding-top: 1px;
  /* border-radius: 50%; */
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  // color: #fff;
  cursor: pointer;
}

.airsupply2 {
  width: 200px;
  height: 30px;
  // background: linear-gradient(0deg, #1b2a4667 18%, #0c12223f 100%);
  // border: 2px solid #15ff00;
  color: #15ff00;
  position: absolute;
  bottom: 77vh;
  right: 27vh;
  // bottom: 60vh;
  // right: 47vh;
  padding-top: 1px;
  /* border-radius: 50%; */
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  // color: #fff;
  cursor: pointer;
}

.airsupplyimg1 {
  width: 30px;
  height: 30px;
  margin-right: 3px;
  background-image: url("../../assets/diy/xuan.gif");
  background-size: 100% 100%;
}

.airsupplyimg2 {
  width: 20px;
  height: 20px;
  margin-right: 3px;
  background-image: url("../../assets/diy/xuan1.png");
  background-size: 100% 100%;
}

.bottomhand {
  display: flex;
  flex-direction: row;
  position: absolute;
  bottom: 10px;
  width: 100%;
  height: 38vh;
  justify-content: space-between;
}

.curve {
  width: 99%;
  height: 100%;
  background-color: #62625f56;
  // background: linear-gradient(to top,#7e7e7e38,#ffffff3b);
  margin-left: 10px;
  // opacity: 0.4;
  // border: 1px solid #15ff00;
}

.curve-top {
  display: flex;
  margin: 10px 0 0 10px;
}

.curve-top-img {
  width: 34px;
  height: 20px;
}

.curve-text {
  width: 200px;
  // height: 20%;
  color: #15ff00;
  font-size: 1.8vh;
  font-weight: 400;
  padding-left: 10px;
  // padding: 8px 0 0 30px;
}

.screw-main {
  width: 100%;
  height: 80%;
  // color: #34a4ff71
}

.record {
  display: flex;
  // justify-content: center;
  align-items: center;
  width: 100%;
}

.record-tem {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #ffa600;
  border-radius: 50%;
}

.record-hum {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #0086D0;
  border-radius: 50%;
  margin-left: 2%;
}

.record-car {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #f700ff;
  border-radius: 50%;
  margin-left: 2%;
}

.record-voc {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #ae00ff;
  border-radius: 50%;
  margin-left: 2%;
}

.record-s {
  color: #15ff00;
  font-size: 1.4vh;
  padding-left: 6px;
  // color: #2e90e057;
}
</style>


// WEBPACK FOOTER //
// src/components/graphically/visuaShow.vue